module.exports = fox._r("components/iframe/images/powered-by.png", __webpack_public_path__ + "components/iframe/images/powered-by.png");


//////////////////
// WEBPACK FOOTER
// ./components/iframe/images/powered-by.png
// module id = 84
// module chunks = 5